import { render, staticRenderFns } from "./DpApplicationConstructionLocationField.vue?vue&type=template&id=1bcdd7d6&scoped=true&"
import script from "./DpApplicationConstructionLocationField.vue?vue&type=script&lang=js&"
export * from "./DpApplicationConstructionLocationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcdd7d6",
  null
  
)

export default component.exports